import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';



@Injectable()
export class TransferService {
    constructor(
        private httpService: HttpService) { }

    //获取各个账户余额
    //chen 2017-01-04
    getUserBalance() {
        let url = AppConfig.GetProdUrl() + "/Funds/GetUserBalance";
        return this.httpService.get(url);
    }

    //转账
    //chen 2017-01-04
    doTransfer(obj){    
        let params={
            From:obj.From,
            To:obj.To,
            Amount:obj.Amount        
        };
        let url = AppConfig.GetProdUrl() + "/Funds/PlatformTransfer";
        return this.httpService.post(url,params);
    }
}




// WEBPACK FOOTER //
// ./src/services/transfer.service.ts